import React from "react";

import styles from "./lang-switch.module.css";

const LangSwitch = () => {
  return (
    <div className={styles.container}>
      <span className={styles.desktopSwitch}>Switch to English</span>
      <div className={styles.mobileSwitch}>Eng</div>
    </div>
  );
};

export default LangSwitch;
